const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } }), { threshold: .18 });
document.querySelectorAll('.reveal,.bar-anim').forEach(el => io.observe(el));
// data-checkout anchors: tech team maps these to Shopify checkout URLs per bundle

// scroll-scrubbed scenes (Apple-style): progress 0→1 as the scene crosses the viewport
const scenes = [...document.querySelectorAll('[data-scene]')];
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
function drive(){
  const vh = innerHeight;
  scenes.forEach(sc => {
    const r = sc.getBoundingClientRect();
    // progress 0 when scene enters low, 1 when scene nears the TOP of the viewport
    // start ~20% later and finish as the image climbs toward the top
    let p = (vh * 0.52 - r.top) / (vh * 0.58);
    p = Math.max(0, Math.min(1, p));
    if (reduced) p = 1;
    sc.querySelector('.p-drive').style.setProperty('--p', p.toFixed(3));
    sc.classList.toggle('active', p > .12 && p < 1.35 && !reduced);
  });
}
addEventListener('scroll', () => requestAnimationFrame(drive), {passive:true});
addEventListener('resize', drive);
drive();

// Timers for Masterclass Live (MSL) and Masterclass Replay Page (MSR)
let DEADLINE_MSL = new Date('2026-08-16T23:59:59-07:00').getTime();
let DEADLINE_MSR = new Date('2026-08-16T23:59:59-07:00').getTime();
const isMasterClassReplayPage = (window.location.pathname).includes('werecover-masterclass-replay');
let DEADLINE_MS = isMasterClassReplayPage ? DEADLINE_MSR : DEADLINE_MSL;
const clock = document.getElementById('countdown');
const timer = setInterval(tickWithDays, 1000);

function tick(){
  let s = Math.max(0, Math.floor((DEADLINE_MS - Date.now())/1000));
  if (s <= 0) {
    clearInterval(timer);
    redirectToCollections();
    return;
  }

  const hh = String(Math.floor(s/3600)).padStart(2,'0');
  const mm = String(Math.floor(s%3600/60)).padStart(2,'0');
  const ss = String(s%60).padStart(2,'0');
  clock.textContent = hh+':'+mm+':'+ss;
}

function tickWithDays(){
  let s = Math.max(0, Math.floor((DEADLINE_MS - Date.now())/1000));
  if (s <= 0) {
    clearInterval(timer);
    redirectToCollections();
    return;
  }

  const dd = Math.floor(s/86400);
  const hh = String(Math.floor(s%86400/3600)).padStart(2,'0');
  const mm = String(Math.floor(s%3600/60)).padStart(2,'0');
  const ss = String(s%60).padStart(2,'0');
  clock.textContent = dd+' Days '+hh+':'+mm+':'+ss;
}

function redirectToCollections() {
   window.location.href = 'https://shop.weshape.com/collections/the-werecover-system';
}